//
//
//
//
//
//
//
//
//
//

import { MessageBox } from 'element-ui';
export default {
  data: function data() {
    return {
      loading: false
    };
  },
  mehtods: {},
  mounted: function mounted() {
    var _this = this;
    this.loading = true;
    this.$store.dispatch('user/tokeninfo').then(function (code) {
      _this.loading = false;
      if (code === '0000000000') {
        _this.$router.push({
          path: '/'
        });
      }
    }).catch(function () {
      MessageBox.confirm('登陆失败，请重新登陆！', '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        showClose: false
      }).then(function () {
        var pturl = '';
        if (process.env.VUE_APP_domain.indexOf('hzbtest') < 0) {
          pturl = '';
        } else {
          pturl = '';
        }
        window.location.href = pturl;
      });
    });
  }
};